(function () {
  'use strict';

  var VARIANT_CLASSES = { v1: 'TL-0078_V1', v2: 'TL-0078_V2' };
  var ABO_DEFAULT_CLASS = 'TL-0078_ABO_DEFAULT';

  var radiosWired = false;
  var defaultApplied = false;

  function activeVariant() {
    if (!document.body) return null;

    for (var key in VARIANT_CLASSES) {
      if (document.body.classList.contains(VARIANT_CLASSES[key])) return key;
    }

    return null;
  }

  /** Klon eines Bausteins aus dem <template>. */
  function part(name) {
    var template = document.getElementById('sh-ab-parts');
    if (!template || !template.content) return null;

    var node = template.content.querySelector('[data-sh-ab-part="' + name + '"]');
    return node ? node.cloneNode(true) : null;
  }

  /** Überschrift „Kaufoption wählen:" über den Karten (V1). */
  function ensureHeading(form, sections) {
    if (form.querySelector('.sh-ab-heading')) return;

    var heading = part('heading');
    if (heading) form.insertBefore(heading, sections);
  }

  /** „Empfohlen"-Badge an der Spar-Abo-Karte (V1). */
  function ensureRecommended(subscriptionSection) {
    if (!subscriptionSection || subscriptionSection.querySelector('.sh-ab-recommended')) return;

    var badge = part('recommended');
    if (badge) subscriptionSection.appendChild(badge);
  }

  /** Label + Chevron am Lieferintervall-Select. */
  function ensureFrequencyParts(variant) {
    var wrapper = document.querySelector('.ProductForm__SectionFrequency');
    if (!wrapper) return;

    if (!wrapper.querySelector('.sh-ab-interval-label')) {
      var label = part('interval-label');
      if (label) {
        label.textContent = label.getAttribute('data-' + variant) || '';
        wrapper.insertBefore(label, wrapper.firstChild);
      }
    }

    if (!wrapper.querySelector('.sh-ab-chevron')) {
      var chevron = part('chevron');
      if (chevron) wrapper.appendChild(chevron);
    }
  }

  /** Zahlungsicons als eigene Zeile unter dem ATC-Button. */
  function ensurePayments(form) {
    if (form.querySelector('.sh-ab-payments')) return;

    var source =
      document.querySelector('#singleSection .ProductForm__SectionPayment') ||
      document.querySelector('.ProductForm__SectionPayment');
    if (!source) return;

    var clone = source.cloneNode(true);
    clone.classList.add('sh-ab-payments');
    form.appendChild(clone);
  }

  /**
   * V2: Preiszeile über die Steuer-/Versandzeile setzen. Verschiebt die bestehenden
   * Preis-Container aus den Karten — sie werden weiter per Selektor vom Theme-JS
   * aktualisiert, egal wo sie im DOM hängen.
   */
  function ensurePriceRow() {
    var chooser = document.querySelector('.ProductVariantChooser');
    var sections = document.querySelector('.ProductForm__Sections');

    // Die Mengen-Kacheln sind ein eigener Customizer-Block. Fehlt er, bekommt die
    // Preiszeile ihren Platz direkt über den Kaufoptionen — sonst zeigt V2 gar keinen
    // Preis, weil die Preise in den Karten ausgeblendet sind.
    var parent = chooser || (sections && sections.parentElement);
    if (!parent) return;

    var anchor = chooser ? chooser.querySelector('p.text-subdued') : sections;

    ['onetime', 'subscription'].forEach(function (type) {
      var price = document.querySelector('[data-js-price-container="' + type + '"]');
      if (!price || price.classList.contains('sh-ab-price')) return;

      price.classList.add('sh-ab-price');
      if (anchor) parent.insertBefore(price, anchor);
      else parent.appendChild(price);
    });
  }

  /**
   * V2: Ersparnis-Badge in die Abo-Preiszeile setzen. Diese Zeile ist nur sichtbar, wenn das
   * Abo gewählt ist — das Badge braucht deshalb keine eigene Zustandslogik.
   */
  function ensureSavingBadge() {
    var price = document.querySelector('.sh-ab-price[data-js-price-container="subscription"]');
    if (!price || price.querySelector('.sh-ab-saving')) return;

    var badge = part('saving');
    if (badge) price.appendChild(badge);
  }

  /** Toggle-Zeile (V2) einfügen und mit den vorhandenen Radios verbinden. */
  function ensureToggle(subscriptionSection) {
    if (!subscriptionSection || subscriptionSection.querySelector('.sh-ab-toggle')) return;

    var toggle = part('toggle');
    if (!toggle) return;

    subscriptionSection.insertBefore(toggle, subscriptionSection.firstChild);

    // Sonst liest der Karten-Handler des Themes „Toggle aus" als „Karte gewählt".
    toggle.addEventListener('click', function (event) {
      event.stopPropagation();
    });

    var input = toggle.querySelector('.sh-ab-toggle__input');
    if (!input) return;

    input.addEventListener('change', function () {
      selectDelivery(input.checked ? 'subscription' : 'onetime');
    });
  }

  /**
   * Kaufoption über das bestehende Radio wählen, damit die Theme-Logik greift.
   * `bubbles: true` ist zwingend — die Kachelpreise hängen an einem delegierten
   * Listener auf `document` (product-variant-chooser.liquid).
   */
  function selectDelivery(type) {
    var radio = document.getElementById(
      type === 'subscription' ? 'delivery-subscription' : 'delivery-onetime'
    );
    if (!radio || radio.checked) return;

    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /** Toggle-Stellung an den tatsächlichen Radio-Zustand angleichen. */
  function syncToggle() {
    var input = document.querySelector('.sh-ab-toggle__input');
    var subscription = document.getElementById('delivery-subscription');
    if (input && subscription) input.checked = subscription.checked;
  }

  /** Prozentwert in Toggle-Titel und Ersparnis-Badge aus dem Rabatt-Badge übernehmen. */
  function syncDiscount() {
    var badge = document.querySelector('.ProductForm__SectionHeaderBadge span');
    if (!badge) return;

    var value = badge.textContent.replace(/[^0-9.,%]/g, '').trim();
    if (!value) return;

    document.querySelectorAll('[data-sh-ab-discount]').forEach(function (target) {
      target.textContent = value;
    });
  }

  /** Einmalig: auf Radio-Wechsel hören, egal wer ihn ausgelöst hat. */
  function wireRadios() {
    if (radiosWired) return;

    var radios = document.querySelectorAll('.ProductForm__SectionRadio');
    if (!radios.length) return;

    radiosWired = true;
    Array.prototype.forEach.call(radios, function (radio) {
      radio.addEventListener('change', syncToggle);
    });
  }

  /** Optional: Abo per Default vorausgewählt (Body-Klasse TL-0078_ABO_DEFAULT). */
  function applyDefault() {
    if (defaultApplied) return;
    if (!document.body.classList.contains(ABO_DEFAULT_CLASS)) return;
    if (!document.getElementById('delivery-subscription')) return;

    defaultApplied = true;
    selectDelivery('subscription');
  }

  /** Idempotent — kann nach jedem Theme-Update erneut laufen. */
  function apply() {
    var variant = activeVariant();
    if (!variant) return;

    var sections = document.querySelector('.ProductForm__Sections');
    if (!sections) return;

    var form = sections.parentElement;
    if (!form) return;

    form.classList.add('sh-ab-form');

    var subscriptionSection = document.getElementById('subscriptionSection');

    if (variant === 'v1') {
      ensureHeading(form, sections);
      ensureRecommended(subscriptionSection);
    }

    if (variant === 'v2') {
      ensureToggle(subscriptionSection);
      ensurePriceRow();
      ensureSavingBadge();
      syncDiscount();
    }

    ensureFrequencyParts(variant);
    ensurePayments(form);
    wireRadios();
    applyDefault();
    syncToggle();
  }

  function scheduleApply() {
    window.setTimeout(apply, 0);
  }

  // Theme baut Button/Bestand/Preise neu auf — danach erneut anwenden.
  // Beide Ziele, weil das Theme auf beiden Ebenen feuert.
  ['variant:changed', 'buy-buttons:updated'].forEach(function (eventName) {
    document.addEventListener(eventName, scheduleApply);
    document.documentElement.addEventListener(eventName, scheduleApply);
  });

  // Falls ABlyft die Klasse erst nach dem Laden setzt.
  if (window.MutationObserver && document.body) {
    new MutationObserver(apply).observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
